import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.scss";
import { useState } from "react";
import { RegisterApi } from "@/service/register";
import { BaseInput } from "@/components/common/BaseInputV2";
import { SendCode } from "../../../components/SendCode";
import { codeVerify, phoneVerify } from "../../../util";
import { useTranslations } from "next-intl";
export const PhoneForm = props => {
  const t = useTranslations();
  const [verifyPhoneText, setVerifyPhoneText] = useState("");
  const [verifyCodeText, setVerifyCodeText] = useState("");
  const {
    needVerify,
    changeAccountData,
    data,
    innerStyle = {},
    style = {},
    verifyTextType = "default"
  } = props;
  const isBlurVerifyText = verifyTextType === "blur";
  return /*#__PURE__*/_jsxs("div", {
    className: styles.phoneFormContainer,
    style: style,
    children: [/*#__PURE__*/_jsx(BaseInput, {
      value: data.phone,
      onChange: e => {
        changeAccountData({
          phone: e.target.value
        });
      },
      // className={styles.phone}
      placeholder: t("Login_Phone_Placeholder"),
      style: innerStyle,
      verifyText: needVerify ? verifyPhoneText : "",
      type: "number",
      verifyFn: v => {
        if (isBlurVerifyText) return !verifyPhoneText;
        const {
          isVerify,
          verifyText
        } = phoneVerify(v, t);
        setVerifyPhoneText(verifyText);
        return needVerify ? isVerify : true;
      },
      onBlur: e => {
        const value = e.target.value;
        if (isBlurVerifyText) {
          const {
            verifyText
          } = phoneVerify(value, t);
          setVerifyPhoneText(verifyText);
        }
      },
      maxLength: 11
    }), /*#__PURE__*/_jsx(BaseInput, {
      value: data.p_code,
      onChange: e => {
        var _e_target;
        changeAccountData({
          p_code: (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value
        });
      },
      style: innerStyle,
      className: styles.phone_code,
      placeholder: t("Login_ActivationCode_Placeholder"),
      type: "number",
      verifyText: needVerify ? verifyCodeText : "",
      verifyFn: v => {
        if (isBlurVerifyText) return !verifyCodeText;
        const {
          isVerify,
          verifyText
        } = codeVerify(v, t);
        setVerifyCodeText(verifyText);
        return needVerify ? isVerify : true;
      },
      onBlur: e => {
        const value = e.target.value;
        if (isBlurVerifyText) {
          const {
            verifyText
          } = codeVerify(value, t);
          setVerifyCodeText(verifyText);
        }
      },
      maxLength: 10,
      suffix: /*#__PURE__*/_jsx(SendCode, {
        verifyFunc: () => {
          if (!data.phone || data.phone.length !== 11) {
            const {
              verifyText
            } = phoneVerify(data.phone, t);
            setVerifyPhoneText(verifyText);
            return null;
          }
          return RegisterApi.postSendPhoneCode(data.phone, "register_and_login");
        }
      })
    })]
  });
};